import React from "react";
import { css } from "@emotion/react";

type Props = {
    children: React.ReactNode,
    minHeight: number,
}

const BannerContainer: React.FC<Props> = ({
    children,
    minHeight,
 }) => {
    const style = css`
        position: relative;
        width: 100%;
        min-height: ${minHeight}px;
        display: flex;
    `;

    return (
        <div css={style}>{children}</div>
    );
};

export default BannerContainer;